import { ClosableDialog } from 'components/controls/dialogs'
import { Button } from 'components/facets/Button'
import { useTranslation } from 'react-i18next'

export interface LocationsErrorDialogInterface {
  open: boolean
  setOpen: (open: boolean) => void
}

export const LocationsErrorDialog = ({
  open,
  setOpen,
}: LocationsErrorDialogInterface): JSX.Element => {
  const { t } = useTranslation()

  return (
    <ClosableDialog fullWidth={true} open={open} onClose={() => setOpen(false)}>
      <div className="container">{t('orders.picking.missingLocations')}</div>

      <div className="w-100 mt-5">
        <div className="d-flex flex-row justify-content-end">
          <Button variant="contained" onClick={() => setOpen(false)}>
            {t('common.close')}
          </Button>
        </div>
      </div>
    </ClosableDialog>
  )
}
